import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

/** Approve a pending credential request as the signed-in user. */
export function useApproveCredentialRequest() {
  const { credentialRequestService } = useDomainServices();

  return useMutation({
    retry: false,
    mutationFn: (credentialRequestId: string) =>
      credentialRequestService.approve(credentialRequestId),
  });
}

/** Deny a pending credential request. */
export function useDenyCredentialRequest() {
  const { credentialRequestService } = useDomainServices();

  return useMutation({
    retry: false,
    mutationFn: (credentialRequestId: string) =>
      credentialRequestService.deny(credentialRequestId),
  });
}
